import { Chip, ChipProps, alpha } from '@mui/material';
import { ReactNode } from 'react';

type BadgeVariant =
  | 'gray'
  | 'green'
  | 'red'
  | 'amber'
  | 'blue'
  | 'indigo'
  | 'purple'
  | 'pink'
  | 'teal';

interface BadgeProps {
  children: ReactNode;
  variant?: BadgeVariant;
  size?: ChipProps['size'];
}

const variantColors: Record<BadgeVariant, { main: string; text: string }> = {
  gray: { main: '#6b7280', text: '#f3f4f6' },
  green: { main: '#10b981', text: '#d1fae5' },
  red: { main: '#ef4444', text: '#fee2e2' },
  amber: { main: '#f59e0b', text: '#fef3c7' },
  blue: { main: '#3b82f6', text: '#dbeafe' },
  indigo: { main: '#6366f1', text: '#e0e7ff' },
  purple: { main: '#8b5cf6', text: '#ede9fe' },
  pink: { main: '#ec4899', text: '#fce7f3' },
  teal: { main: '#14b8a6', text: '#ccfbf1' },
};

export default function Badge({ children, variant = 'gray', size = 'small' }: BadgeProps) {
  const colors = variantColors[variant];

  return (
    <Chip
      label={children}
      size={size}
      sx={{
        bgcolor: alpha(colors.main, 0.15),
        color: colors.text,
        border: 1,
        borderColor: alpha(colors.main, 0.3),
        fontWeight: 500,
        fontSize: size === 'small' ? '0.75rem' : '0.875rem',
        '& .MuiChip-label': {
          px: 1,
        },
      }}
    />
  );
}

// Helper function to map sentiment to variant
export function sentimentToVariant(sentiment?: string): BadgeVariant {
  const s = (sentiment || '').toLowerCase();
  if (/涨|多|bull|up|买/.test(s)) return 'green';
  if (/跌|空|bear|down|卖/.test(s)) return 'red';
  if (/震荡|中性|观望/.test(s)) return 'amber';
  return 'gray';
}
